export default __webpack_public_path__ + "assets/bahrain-flag.png";